<div class="data" *ngFor="let data of mapData">

    <div class="data-block" *ngIf="data.name != ''">
        <p>Name</p>
        <p>:</p>
        <p>{{data.name}}</p>
    </div>

    <div class="data-block" *ngIf="data.mobileNo != ''">
        <p>Mobile</p>
        <p>:</p>
        <p>{{data.mobileNo}}</p>
    </div>

    <div class="data-block" *ngIf="data.email != ''">
        <p>Email</p>
        <p>:</p>
        <p>{{data.email}}</p>
    </div>

<!-- 
    <div class="data-block" *ngIf="data.applicationFormFor != ''">
        <p>Application Form For</p>
        <p>:</p>
        <p>{{data.applicationFormFor}}</p>
    </div>

    <div class="data-block" *ngIf="data.latestStatus != ''">
        <p>Latest Status</p>
        <p>:</p>
        <p>{{data.latestStatus}}</p>
    </div>

    <div class="data-block" *ngIf="data.installationAddress != ''">
        <p>Installation Address</p>
        <p>:</p>
        <p>{{data.installationAddress}}</p>
    </div> -->

    <!-- <div class="data-block" *ngIf="data.info != ''">
        <p>Info</p>
        <p>:</p>
        <p>{{data.info}}</p>
    </div>

    <div class="data-block" *ngIf="data.buildingUrl != ''">
        <p>Building Proof</p>
        <p>:</p>
        <img src="{{data.buildingUrl}}" alt="">
    </div>

    <div class="data-block" *ngIf="data.photoUrl != ''">
        <p>Photo Proof</p>
        <p>:</p>
        <img src="{{data.photoUrl}}" alt="">
    </div>

    <div class="data-block" *ngIf="data.idProofUrl != ''">
        <p>Id Proof</p>
        <p>:</p>
        <img src="{{data.idProofUrl}}" alt="">
    </div>

    <div class="data-block" *ngIf="data.addressProofUrl != ''">
        <p>Address Proof</p>
        <p>:</p>
        <img src="{{data.addressProofUrl}}" alt="">
    </div>

    <div *ngFor="let list of data.deviceInfoList">
        <div class="data-block" *ngIf="list.deviceId != ''">
            <p>Device Id</p>
            <p>:</p>
            <p>{{list.deviceId}}</p>
        </div>

        <div class="data-block" *ngIf="list.deviceType != ''">
            <p>Device Type</p>
            <p>:</p>
            <p>{{list.deviceType}}</p>
        </div>

        <div class="data-block" *ngIf="list.deviceInfo != ''">
            <p>Device Info</p>
            <p>:</p>
            <p>{{list.deviceInfo}}</p>
        </div>
    
        <div class="data-block" *ngIf="list.devicePhotoUrl != ''">
            <p>Device Proof</p>
            <p>:</p>
            <img src="{{list.devicePhotoUrl}}" alt="">
        </div>
    
    </div> -->
 
</div>



